import { render, staticRenderFns } from "./unorderedList.vue?vue&type=template&id=fce1e9f6&scoped=true&"
import script from "./unorderedList.vue?vue&type=script&lang=js&"
export * from "./unorderedList.vue?vue&type=script&lang=js&"
import style0 from "./unorderedList.vue?vue&type=style&index=0&id=fce1e9f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce1e9f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
